import "core-js/modules/es6.function.name";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";

/** @jsx _j **/

/** @jsxFrag _f **/
var _require = require('astroturf'),
    _j = _require.jsx,
    _f = _require.F;

// eslint-disable-next-line import/no-cycle
import Heading from './Heading';
import DocBlock from './JsDocBlock';
import TitleSignature from './JsDocTitleSignature';
import List from './List';

var DocList = function DocList(_ref) {
  var elements = _ref.elements,
      level = _ref.level,
      ignoreParams = _ref.ignoreParams;
  return _j(List, null, elements.filter(function (param) {
    return !ignoreParams.includes(param.name);
  }).map(function (param) {
    return _j("li", {
      key: param.name,
      css: [require("./JsDocMembers-CssProp1_li.module.css"), []]
    }, _j(TitleSignature, {
      definition: param
    }), _j(DocBlock, {
      definition: param,
      depth: level + 1
    }));
  }));
};

function JsDocMembers(_ref2) {
  var definition = _ref2.definition,
      _ref2$level = _ref2.level,
      level = _ref2$level === void 0 ? 1 : _ref2$level,
      _ref2$ignoreParams = _ref2.ignoreParams,
      ignoreParams = _ref2$ignoreParams === void 0 ? [] : _ref2$ignoreParams;

  if (definition.params && definition.params.length > 0) {
    return _j(_f, null, _j(Heading, {
      level: level
    }, "Parameters"), _j(DocList, {
      level: level,
      elements: definition.params,
      ignoreParams: ignoreParams
    }));
  }

  if (definition.properties && definition.properties.length > 0) {
    return _j(_f, null, level === 1 && _j(Heading, {
      level: level
    }, "Properties"), _j(DocList, {
      level: level,
      elements: definition.properties,
      ignoreParams: ignoreParams
    }));
  }

  if (definition.members && definition.members.static && definition.members.static.length > 0) {
    return _j(_f, null, level === 1 && _j(Heading, {
      level: level
    }, "Fields"), _j(DocList, {
      level: level,
      elements: definition.members.static,
      ignoreParams: ignoreParams
    }));
  }

  if (definition.type && definition.type.typeDef) {
    return _j(JsDocMembers, {
      definition: definition.type.typeDef,
      level: level
    });
  }

  return null;
}

export default JsDocMembers;
export var fragment = "1069192781";